import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  namedAttributes: {
    name: String,
    statement: String,
    executionTime: String,
  },
  defaults: {
    name: null,
    statement: null,
    executionTime: null,
  },
});

export { Model as default };
